export default __webpack_public_path__ + "static/332-19596c29e0eef52c8c60c6a60c0dd6c1.gif";